import type { JSX } from 'react';

import classNames from 'classnames';

import styles from './PageHeader.module.css';

function PageHeader({
  title,
  description,
  children,
  subPage = false,
}: {
  title: string;
  description?: string;
  children?: React.ReactNode;
  subPage?: boolean;
}): JSX.Element {
  const Tag = subPage ? 'h2' : 'h1';
  return (
    <div className={classNames(styles.Header, { [styles.Primary]: !subPage })}>
      <div className={styles.HeaderContent}>
        <Tag>{title}</Tag>
        <p
          className={classNames({
            [styles.HeaderDescription]: !subPage,
          })}
        >
          {description}
        </p>
      </div>
      <div className={styles.HeaderActions}>{children}</div>
    </div>
  );
}

export { PageHeader };
